import RaikoTextEditor from "../raikoTextEditor/RaikoTextEditor";
import {RaikoCustomBlogEditorUtils} from "./RaikoCustomBlogEditorUtils";

export default function (
    {
        index,
        amount,
        changeAmount,
        editorData,
        setEditorData
    }) {

    const raikoCustomEditorUtils = new RaikoCustomBlogEditorUtils();

    return (
        <div className={`editorItemContainer`} key={index}>
            <div className={`editorItem`}>
                <RaikoTextEditor
                    text={amount}
                    setText={changeAmount}
                />
                {raikoCustomEditorUtils.deleteInterface(index, editorData, setEditorData)}
            </div>
            {raikoCustomEditorUtils.insertInterface(index, editorData, setEditorData)}
        </div>
    )
}